export default {
	state: {
		// sConektaPublicKey: "key_K2SWaThgdMpdOE6plJTfvZF",
		// sHttpConexion: 'http://localhost:8080/',       // dev: proxy Vue → Docker PHP

		// sHttpConexion: 'http://localhost/tecnoforce/', // Apache local (configuración anterior)
		sHttpConexion: "https://tecnoforce.com.mx/", // producción
		sConektaPublicKey: "key_U8DRjTIOw7AVcaxOeKit5Yo", // llave prod Conekta
	},
	getters: {
		getEnlaceConexion(state) {
			return state.sHttpConexion;
		},
		getConektaPublicKey(state) {
			return state.sConektaPublicKey;
		},
	},
};
